import { useMemo } from 'react';

interface IProps {
  selectedOptionId?: number | null;
  checked?: number | null;
  allOptions?: { id: number }[];
}

export const useSelectedOption = ({ selectedOptionId, checked, allOptions = [] }: IProps) => {
  const { optionId, letter } = useMemo(() => {
    let effectiveId: number | null = null;

    if (selectedOptionId !== undefined) {
      effectiveId = selectedOptionId;
    } else if (checked && checked !== 0) {
      effectiveId = checked;
    }

    const index = allOptions.findIndex(o => o.id === effectiveId);
    const letter = effectiveId && index >= 0 ? String.fromCharCode(65 + index) : null;

    return { optionId: effectiveId, letter };
  }, [selectedOptionId, checked, allOptions]);

  return { optionId, letter };
};
